import { CreatorIntegrationsApiClient } from '@fourthwall/services/dist/CreatorIntegrationsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useRefreshListsMutation = createMutationHook(
  CreatorIntegrationsApiClient.refreshMailchimpLists,
  {
    mutationKey: ['refreshMailchimpLists'],
  },
)
